import { roundToPrecision } from '#util/math'

const PX_PER_IN = 96
const PX_PER_CH = 9.6
const IN_PER_CM = 2.54

type UnitType = 'in' | 'cm' | 'px' | 'ch'

// Conversion factors to pixels (the canonical intermediate unit)
const toPx: Record<UnitType, number> = {
  px: 1,
  in: PX_PER_IN,
  cm: PX_PER_IN / IN_PER_CM,
  ch: PX_PER_CH,
}

export class Unit {
  constructor(
    readonly value: number,
    readonly unit: UnitType,
  ) {}

  toRounded(precision: 1 | 2 | 3 = 2): number {
    return roundToPrecision(this.value, precision)
  }

  toRoundedCssValue(precision: 1 | 2 | 3 = 2): string {
    return `${this.toRounded(precision)}${this.unit}`
  }

  to(target: UnitType) {
    if (this.unit === target) return this
    const pxValue = this.value * toPx[this.unit]
    return new Unit(pxValue / toPx[target], target)
  }

  toInches() {
    return this.to('in')
  }
  toPx() {
    return this.to('px')
  }
  toCh() {
    return this.to('ch')
  }
  toCm() {
    return this.to('cm')
  }
}

export const inches = (value: number) => new Unit(value, 'in')
export const centimeters = (value: number) => new Unit(value, 'cm')
export const chars = (value: number) => new Unit(value, 'ch')
export const pixels = (value: number) => new Unit(value, 'px')
